import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  wrapper: function wrapper() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: flex;\n    "])));
  },
  inner: function inner() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      width: 100%;\n    "])));
  },
  fixed: function fixed() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      position: fixed;\n    "])));
  },
  stopped: function stopped() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      position: relative;\n    "])));
  },
  container: function container() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      flex: auto;\n      width: 100%;\n    "])));
  }
});